import type { StockPayload, SymbolChunk, SymbolDirectory } from "./types";

export async function loadStockPayload(): Promise<StockPayload> {
  const response = await fetch(`/data/latest.json?ts=${Date.now()}`);
  if (!response.ok) {
    throw new Error(`Unable to load stock payload: HTTP ${response.status}`);
  }
  return response.json() as Promise<StockPayload>;
}

export async function loadSymbolDirectory(): Promise<SymbolDirectory> {
  const response = await fetch(`/data/symbols.json?ts=${Date.now()}`);
  if (!response.ok) {
    throw new Error(`Unable to load symbol directory: HTTP ${response.status}`);
  }
  const directory = (await response.json()) as SymbolDirectory;
  if (!directory.chunks?.length) {
    return directory;
  }
  const chunks = await Promise.all(
    directory.chunks.map(async (chunk) => {
      const chunkResponse = await fetch(`/data/${chunk.path}?ts=${Date.now()}`);
      if (!chunkResponse.ok) {
        throw new Error(`Unable to load symbol chunk ${chunk.path}: HTTP ${chunkResponse.status}`);
      }
      return (await chunkResponse.json()) as SymbolChunk;
    })
  );
  return {
    ...directory,
    symbols: chunks.sort((a, b) => a.index - b.index).flatMap((chunk) => chunk.symbols)
  };
}
